<template>
    <vx-card>
        <vs-tabs alignment="fixed">
            <vs-tab label="Generar códigos" @click="menu = 0;" v-if="userRoot">
                <vs-tabs class="mt-4">
                    <vs-tab label="Elegir libro" icon-pack="feather" icon="icon-book">
                        <vs-divider></vs-divider>
                        <GenerarCodigosVue class="mt-3" v-if="menu == 0"/>
                    </vs-tab>
                </vs-tabs>
            </vs-tab>
            <vs-tab label="Búsqueda" @click="menu = 1;" v-if="userRoot">
                <vs-tabs class="mt-4">
                    <vs-tab label="Buscar" icon-pack="feather" icon="icon-search">
                        <vs-divider></vs-divider>
                        <seccionBuscarVue v-if="menu == 1"/>
                    </vs-tab>
                </vs-tabs>
            </vs-tab>
            <vs-tab label="Importaciones" @click="menu = 2;">
                <ScreenImportacionesVue v-if="menu == 2" :userRoot="userRoot"/>
            </vs-tab>
        </vs-tabs>
    </vx-card>
</template>
<script>
const GenerarCodigosVue         = () => import('./components/GenerarCodigos/GenerarCodigos.vue');
const seccionBuscarVue          = () => import('./components/seccionBuscar.vue');
const ScreenImportacionesVue    = () => import('./components/Importaciones/ScreenImportaciones.vue');
import GeneralMixin from "@/mixins/GeneralMixin";
export default{
    mixins: [GeneralMixin],
    components:{
        GenerarCodigosVue,
        seccionBuscarVue,
        ScreenImportacionesVue,
    },
    data(){
        return{
            usuario:[],
            menu:2,
            userRoot:false,
        }
    },
    created(){
        let me = this;
        me.usuario = JSON.parse(localStorage.getItem("usuario"))[0]
    },
    mounted(){
        let me = this;
        me.getUserRoot().then( r => { if(r.data.length > 0) { me.userRoot = true } } )
        if(me.userRoot){
            me.menu = 0;
        }
    },
    methods:{
    }
}
</script>